import { initialBolOrderState } from '../../data/data';
import { IOrderBolViewModel } from '../../models/create-orders/order-bol.interface';
import { createStore } from '../store';

export const {
  Provider: BolOrderProvider,
  useStore,
  useSetStore
} = createStore<IOrderBolViewModel>(initialBolOrderState);
